import { useGetStudySitePerformance } from './get-study-site-performance/hook';

export const StudySitePerformance = {
  useGetStudySitePerformance,
};
